import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/Base.service';


@Injectable({
    providedIn: 'root'
})
export class NovidadeCategoriaService extends BaseService {
	constructor(){
		super('/novidadeCategoria/')
	}
}
